module.exports = __webpack_public_path__ + "static/media/MovingApp_android_6_preview.3a369f6f.jpg";